exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ant-alert-info{position:absolute;top:50%}[dir] .ant-alert-info{background:rgba(0,0,0,0);border-color:#fff}[dir=ltr] .ant-alert-info{left:50%;transform:translate(-50%, -50%)}[dir=rtl] .ant-alert-info{right:50%;transform:translate(50%, -50%)}.ant-alert-info .ant-alert-icon{color:red}.ant-alert-info .ant-alert-message{color:red}", ""]);

